import React from 'react'
const ViewButon = ({ direction, handleClick, tupleCount, isNewHighRps }) => {
    return (
        <button
            className="h-8 w-174 bg-white flex flex-middle flex-center gap-8 c-pointer viewButton-border c-3366cc"
            onClick={() => handleClick()}
            style={isNewHighRps?{background:"#1A1A1A", color:'white',border: '1px solid #1A1A1A', zIndex: 3}:{}}
        >
            <p className="fw-600 fs-3">
                {direction === 'down' ? 'View all ' + tupleCount + ' options' : 'Hide all ' + tupleCount + ' options'}
            </p>
            <div
                className="flex flex-middle"
                style={{
                    transform: direction === 'down' ? 'rotate(-180deg)' : '',
                    transitionDuration: '0.7s'
                }}
            >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12 10L8 6L4 10"
                        stroke={isNewHighRps?"#FFFFFF":'#3366CC'}
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
        </button>
    )
}
export default ViewButon
